import { BaseModel } from './base-model';

export class NotificationPopup extends BaseModel {

	public id: string;
	public message: BaseNotificationPopup;
	public userId: string;
	public isRead: boolean;
	public isOpen?: boolean;

  constructor() {
    super();
    this.id = null;
    this.message = null;
    this.userId = null;
    this.isRead = null;
		this.isOpen = false;
  }

}

export class BaseNotificationPopup extends BaseModel {
	public id: string;
	public title: string;
	public body: string;
	public profiles: Array<string>;

	constructor() {
    super();
    this.id = null;
    this.title = null;
    this.body = null;
    this.profiles = [];
  }
}
